RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.BaseStepModalBody = RivalIQ.views.LayoutView.extend({
        ui: {
            step: '.x-step',
            content: '.modal-content'
        },

        regions: {
            body: '.modal-body'
        },

        events: {
            'click @ui.step': 'onStepClick'
        },
        templateFields: ['title', 'stepText', 'stepClassName'],
        className: 'modal-content',
        template: '#baseStepModalTemplate',
        initialize: function () {
            const me = this;

            const parentModelAttrs = _.get(me.model, 'attributes') || {};
            const steps = me.steps;
            me.model = new Backbone.Model(_.defaults(parentModelAttrs, {
                step: 0
            }));
            me.listenTo(me.model, 'change:step', me.render);
            me.collection = new Backbone.Collection(steps);
        },

        marshallModelToTemplateFields: function (model) {
            const me = this;

            const footerHtml = model.get('footerHtml');

            return _.reduce(me.templateFields, function (memo, field) {
                memo[field] = model.get(field);
                return memo;
            }, {
                footerHtml: footerHtml?.(me.model)
            });
        },

        getStep: function () {
            const me = this;
            return me.collection.at(me.model.get('step'));
        },
        serializeData: function () {
            const me = this;
            const stepData = me.getStep();
            const data = me.marshallModelToTemplateFields(stepData);
            data.modalBodyClass = me.modalBodyClass || '';

            return data;
        },
        onRender: function () {
            const me = this;
            me.showStep();
        },
        modalHelpers: '',
        showStep: function () {
            const me = this;

            const step = me.getStep();
            const Body = step.get('body');
            const view = _.extend(new Body({
                model: me.model,
                trackingOptions: me.getOption('trackingOptions')
            }), {
                modalHelpers: {
                    setStepAttributes: function (attrs) {
                        me.ui.step.attr(attrs);
                    },
                    setStepClassName: function (className) {
                        let cls = className;
                        if (_.isArray(className)) {
                            cls = className.join(' ');
                        }
                        me.ui.step.addClass(cls);
                    },
                    setStepDisabledState: function (disabled) {
                        me.ui.step.toggleClass('btn-disabled', disabled);
                        me.ui.step.prop('disabled', disabled);
                    },
                    renderMessage: function (message) {
                        if (message) {
                            me.ui.message.html(message);
                        } else {
                            me.ui.message.empty();
                        }
                    }
                }
            });

            if (step.get('modalClass')) {
                me.$el.addClass(step.get('modalClass'));
            }

            me.listenTo(view, 'step', me.onStepClick);

            me.body.show(view);
        },
        onStepClick: function () {
            const me = this;
            const view = me.body.currentView;
            if (view.satisfied()) {
                if (view.beforeNextStep) {
                    view.beforeNextStep();
                }

                me.model.set({
                    step: me.model.get('step') + 1
                });
            }
        }
    });

    views.BaseStepModal = Marionette.LayoutView.extend({
        className: 'modal fade',
        attributes: {
            tabindex: '-1',
            role: 'dialog',
            'aria-hidden': true,
            'data-backdrop': 'static'
        },
        regions: {
            content: '.modal-dialog'
        },
        events: {
            'shown.bs.modal': 'onShown',
            'hidden.bs.modal': 'onHidden'
        },
        template: function () {
            return $.tagHtml('div', {
                class: ['modal-dialog', 'modal-ml']
            });
        },

        onHidden: _.noop,

        modalBody: null, // override
        onRender: function () {
            const me = this;
            const modalBody = me.modalBody;
            if (modalBody) {
                const view = new modalBody({
                    model: me.model,
                    trackingOptions: me.getOption('trackingOptions')
                });
                me.content.show(view);
            }
        },
        onShown: function () {
            const me = this;
            const modal = me.content.currentView;
            const step = modal.body.currentView;
            if (step.onShown) {
                step.onShown();
            }
        }
    });
});
